"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.declOfNum = void 0;
function declOfNum(number, titles) {
    let _number = Math.abs(number);
    let _titles = [...titles];
    if (_titles.length < 3)
        _titles[2] = _titles[1];
    const cases = [2, 0, 1, 1, 1, 2];
    return _titles[_number % 100 > 4 && _number % 100 < 20
        ? 2
        : cases[_number % 10 < 5 ? _number % 10 : 5]];
}
exports.declOfNum = declOfNum;
